import { FAQ } from './FAQ';

export const Resources = () => {
  return (
    <div className="min-h-screen bg-white">
      <FAQ />
    </div>
  );
};

export default Resources;
